var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPensiunHijrah(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 229.61 112.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:32.8px;fill:#61298a;font-family:FSLola-ExtraBoldItalic, FS Lola;font-weight:800;font-style:italic;}.cls-2{letter-spacing:-0.02em;}.cls-3,.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#80c342;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#5d991d;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 89.26,
    y1: 80.07,
    x2: 113.18,
    y2: 41.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#9420d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#61298a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290a44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 147.75,
    y1: 64.17,
    x2: 120.93,
    y2: 43.39,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 104.09)"
  }, "Pensiun Hij", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 177.35,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 190.31,
    y: 0
  }, "ah")), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.65,62.49C100.38,57,94,47.33,96.06,35.5c.29-1.64,2.09-1.64,2,.26-.29,4.65.73,8.7,4.4,11.81a11.79,11.79,0,0,1-.83-5.14c.09-1.54,1.89-1.57,2,0,.5,5.58,9.18,4.32,9.81,14.45.22,3.51,4.23,6.29,5.79,9.32C119.23,66.22,116.46,66.63,110.65,62.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.8,45.38c-6-6.9-5.85-13.41,0-19.55C120.65,32,120.81,38.48,114.8,45.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.24,26.34C93.52,23.2,89.93,16.88,92,7.64,101.13,10.15,105,16.28,103.24,26.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.12,9.46c-3.78-2.58-4.52-5.75-2.47-9.46C106.26,2.23,107.16,5.36,105.12,9.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.38,20.81c-3.57-.36-5.28-2.27-5.25-5.6C84.46,15.4,86.25,17.22,86.38,20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.66,40.09c-9.81-1-14.47-6.27-14.37-15.42C86.42,25.22,91.33,30.23,91.66,40.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.55,53.22c-8.4,1.74-13.65-1.39-16-9C80.29,42.27,85.68,45.13,88.55,53.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.57,68.23c-10.56,4.62-18.33,2-23.5-7.37C91.66,56.14,99.54,58.41,105.57,68.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117,57.13a2,2,0,0,1,0-.23c.63-10.13,9.31-8.87,9.81-14.45.14-1.59,1.94-1.56,2,0a11.64,11.64,0,0,1-.83,5.14c3.68-3.11,4.7-7.16,4.4-11.81-.12-1.9,1.68-1.9,2-.26,2,11.52-4,21-13.78,26.55-.5-.63-1-1.24-1.55-1.86A11.12,11.12,0,0,1,117,57.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.36,26.34c9.72-3.14,13.31-9.46,11.25-18.7C128.47,10.15,124.58,16.28,126.36,26.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.48,9.46C128.26,6.88,129,3.71,127,0,123.34,2.23,122.44,5.36,124.48,9.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.22,20.81c3.58-.36,5.28-2.27,5.25-5.6C145.15,15.4,143.35,17.22,143.22,20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.94,40.09c9.82-1,14.47-6.27,14.37-15.42C143.18,25.22,138.28,30.23,137.94,40.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.05,53.22c8.41,1.74,13.65-1.39,16-9C149.32,42.27,143.92,45.13,141.05,53.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124,68.23c10.56,4.62,18.32,2,23.5-7.37C138,56.14,130.07,58.41,124,68.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.8,19.39c3-3.45,2.93-6.7,0-9.77C111.88,12.69,111.8,15.94,114.8,19.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92,7.64l10.66,18.09S88.58,23.06,92,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.61,7.64l-11.25,18.7S141.2,23.24,137.61,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.05,53.22l16-9S154.61,56.25,141.05,53.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124,68.23l23.5-7.37S140.34,75.94,124,68.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82.07,60.86l23.5,7.37S90.47,75.87,82.07,60.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensiunHijrah);
export default __webpack_public_path__ + "static/media/pensiun-hijrah.647f9cffa09a02493ced835d119aec58.svg";
export { ForwardRef as ReactComponent };